import triggerTracking from '@blueprint/tracking';
import { WithOptimizelyProps } from 'shared/optimizely';

/**
 * An Optimizely experiment hook for triggering tracking. Only shows tracking when user haven't seen the experiment before and be persistent in future sessions (i.e. saved experiments to local storage).
 *
 */
const useExperiment = (
    optimizely: WithOptimizelyProps['optimizely'],
    experimentName: string
) => {
    const optimizelyVariation = optimizely?.activate(experimentName);

    const setExperimentToStorage = () => {
        const localStorageItem = window.localStorage?.getItem(
            'rp_experiment_enabled'
        );

        const data = JSON.parse(localStorageItem || '{}');
        data[experimentName] = true;

        window.localStorage?.setItem(
            'rp_experiment_enabled',
            JSON.stringify(data)
        );
    };

    const removeExperimentFromStorage = () => {
        const localStorageItem = window.localStorage?.getItem(
            'rp_experiment_enabled'
        );
        if (localStorageItem) {
            const data = JSON.parse(localStorageItem as string);

            if (data[experimentName]) {
                delete data[experimentName];

                window.localStorage?.setItem(
                    'rp_experiment_enabled',
                    JSON.stringify(data)
                );
            }

            return;
        }
    };

    const isExperimentExistedForUser = () => {
        const localStorageItem = window.localStorage?.getItem(
            'rp_experiment_enabled'
        );
        if (localStorageItem) {
            const data = JSON.parse(localStorageItem as string);
            return data.hasOwnProperty(experimentName);
        }

        return false;
    };

    const triggerExperimentTracking = () => {
        if (optimizelyVariation && !isExperimentExistedForUser()) {
            triggerTracking({
                event: 'GAEvent',
                eventCategory: 'optimizely',
                eventAction: experimentName,
                eventLabel: optimizelyVariation || ''
            });

            setExperimentToStorage();
        }

        if (
            optimizelyVariation === null &&
            window.localStorage?.getItem('rp_experiment_enabled')
        ) {
            // remove experiment from storage for cases like cancel_experiment flag etc.
            removeExperimentFromStorage();
        }
    };

    return {
        triggerExperimentTracking,
        optimizelyVariation,
        isExperimentExistedForUser
    };
};

export default useExperiment;
